// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-forecast';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm10.75 12.5a1.75 1.75 0 1 1-1.276 2.947l-3 1.499a1.75 1.75 0 1 1-.448-.893l3-1.499A1.75 1.75 0 0 1 10.75 12.5Zm-6 4a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm2-3a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm2-3a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm2-4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm0 1a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z' />
);

export const viewBox = '0 0 22 22';
